module.exports = __webpack_public_path__ + "static/media/manam-text.2c5574e2.svg";